import { render, staticRenderFns } from "./AccettazioneList.vue?vue&type=template&id=a3bef376"
import script from "./AccettazioneList.vue?vue&type=script&lang=js"
export * from "./AccettazioneList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports